import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Destination } from 'src/objects/destination';
import { MappedArea } from 'src/objects/mapped-area';

import { ApplicationState, MappedAreaSelectors } from '../reducers';
import { MappedAreaActions } from './actions';
import { BaseActionService } from './base.action.service';

@Injectable({
  providedIn: 'root'
})
export class MappedAreaActionService
  extends BaseActionService<ApplicationState> {
  protected store: Store<ApplicationState>;


  constructor() {
    const store = inject<Store<ApplicationState>>(Store);

    super(store);

    this.store = store;
  }

  readonly mappedArea = this.selectSignal(MappedAreaSelectors.getMappedArea);
  readonly mappedAreas = this.selectSignal(MappedAreaSelectors.getMappedAreas);
  readonly mappedAreaError = this.selectSignal(MappedAreaSelectors.getMappedAreaError);

  loadMappedArea(payload: { id: number }) {
    super.load(MappedAreaActions.loadMappedArea(payload));
  }

  loadMappedAreas(payload: { destination: Destination }) {
    super.load(MappedAreaActions.loadMappedAreas(payload));
  }

  selectMappedArea(payload: { mappedArea: MappedArea | null }) {
    super.load(MappedAreaActions.setMappedArea(payload));
  }

  getMappedArea(): Observable<MappedArea | null> {
    return super.get(MappedAreaSelectors.getMappedArea);
  }

  getMappedAreas(): Observable<MappedArea[] | null> {
    return super.get(MappedAreaSelectors.getMappedAreas);
  }

  getMappedAreaError(): Observable<Error | null> {
    return super.get(MappedAreaSelectors.getMappedAreaError);
  }
}
